"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var Icons_1 = require("../icons/Icons");
var TabStyles_1 = require("../styles/TabStyles");
var Declarative_1 = require("../utils/Declarative");
var InteractiveDom_1 = require("../utils/InteractiveDom");
var DomWidgets_1 = require("./DomWidgets");
var DynamicThemeComponent_1 = require("./DynamicThemeComponent");
var FocusIndicators_1 = require("../styles/FocusIndicators");
var focusStyleName = TypeStyle.style({
    $nest: {
        '&.focus::after': {
            borderRadius: 7,
        }
    }
});
var getStyles = function () {
    return {
        baseDiv: {
            flexShrink: 0,
            height: Icons_1.RadioButtonIcon.height,
            marginLeft: TabStyles_1.TabStyles.Spacing.DefaultSpace - Icons_1.RadioButtonIcon.padding,
            marginRight: TabStyles_1.TabStyles.Spacing.DefaultSpace - Icons_1.RadioButtonIcon.padding,
            minWidth: Icons_1.RadioButtonIcon.width,
            width: Icons_1.RadioButtonIcon.width,
        },
        noLeftMargin: {
            marginLeft: -Icons_1.RadioButtonIcon.padding
        },
        radioButton: {
            cursor: 'default',
            height: Icons_1.RadioButtonIcon.height,
            margin: 0,
            opacity: 0,
            verticalAlign: 'top',
            width: Icons_1.RadioButtonIcon.width,
        },
        fakeRadioButton: {
            height: Icons_1.RadioButtonIcon.height,
            position: 'absolute',
            verticalAlign: 'top',
            width: Icons_1.RadioButtonIcon.width,
        }
    };
};
function getRadioButtonIcon(props, state) {
    var iconState = { disabled: props.disabled, checked: props.checked, hover: props.hover || state.hover, focus: state.focus };
    return Icons_1.RadioButtonIcon.icon(iconState);
}
exports.getRadioButtonIcon = getRadioButtonIcon;
var RadioButtonWidget = /** @class */ (function (_super) {
    tslib_1.__extends(RadioButtonWidget, _super);
    function RadioButtonWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.handleFormChange = function (event) {
            // IE bug fix: https://github.com/facebook/react/issues/4457
            if (_this.props.disabled || !_this.props.handleChange) {
                return;
            }
            if (!_this.props.checked) {
                _this.props.handleChange(_this.props.value, _this.props.index);
            }
        };
        _this.handleActive = function (active) {
            _this.setState({ active: active });
        };
        _this.handleFocus = function (focus) {
            _this.setState({ focus: !_this.state.active && focus }); // We only set the focus styling if triggered by keyboard navigation
        };
        _this.handleHover = function (hover) {
            _this.setState({ hover: hover });
        };
        return _this;
    }
    RadioButtonWidget.prototype.render = function () {
        var icon = getRadioButtonIcon(this.props, this.state);
        var styles = getStyles();
        var baseStyle = tslib_1.__assign({}, styles.baseDiv, Declarative_1.conditional(this.props.removeLeftMargin, styles.noLeftMargin));
        return (React.createElement(InteractiveDom_1.InteractiveDomWrapper, { handleHover: this.handleHover, handleFocus: this.handleFocus, handleActive: this.handleActive },
            React.createElement(DomWidgets_1.InlineBlock, { className: TypeStyle.classes(FocusIndicators_1.SVGInputFocusIndicatorBase, focusStyleName, this.state.focus && 'focus'), style: baseStyle },
                React.createElement(DomWidgets_1.Img, { src: icon, style: styles.fakeRadioButton }),
                React.createElement("input", { checked: this.props.checked, "data-tb-test-id": this.props.testId + '-RadioButton', disabled: this.props.disabled, id: this.props.id, name: this.props.groupName, onChange: this.handleFormChange, style: styles.radioButton, type: 'radio', 
                    // tslint:disable-next-line:no-any
                    value: this.props.value }))));
    };
    return RadioButtonWidget;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.RadioButtonWidget = RadioButtonWidget;
//# sourceMappingURL=RadioButtonWidget.js.map